export default "__VITE_PUBLIC_ASSET__c79f6606__"